<script>
import GenericCrud from "@forms/GenericCrud.vue";
import api from "@services/api";

export default {
  extends: GenericCrud,
  props: {
    table: {
      type: String,
      default: "Usuario"
    }
  },
  created() {
    // Novo
    if (!this.$route.params.id) {
      this.getPerfilList();
      this.getClienteList();
      this.getConsultorList();
    }
  },
  data: () => ({
    perfilList: [],
    consultorList: {},
    clienteList: {},
    perfilId: undefined,
    associaConsultor: false,
    associaCliente: false,
    consultorId: undefined,
    clienteId: undefined
  }),
  watch: {
    perfilId: function() {
      this.item.perfilId = this.perfilId;
      let perfil = this.perfilList.filter(p => p.id === this.perfilId)[0];
      this.associaConsultor = perfil.associaConsultor;
      this.associaCliente = perfil.associaCliente;
    },
    consultorId: function() {
      this.item.consultorId = this.consultorId;
      this.item.clienteId = undefined;
    },
    clienteId: function() {
      this.item.consultorId = undefined;
      this.item.clienteId = this.clienteId;
    }
  },
  methods: {
    get(id) {
      this.getPerfilList();
      this.getClienteList();
      this.getConsultorList();
      api.get(`crud/${this.table}/${id}`).then(response => {
        this.item = response.data["data"];
        if (this.item.consultorId) {
          this.consultorId = this.item.consultorId;
        }
        if (this.item.clienteId) {
          this.clienteId = this.item.clienteId;
        }
        if (this.perfilList.length > 0) {
          this.perfilId = this.item.perfilId;
        }
      });
    },
    getClienteList() {
      api
        .get(`crud/Cliente`, {
          params: {
            sortBy: "nome",
            sortOrder: "ASC"
          }
        })
        .then(response => (this.clienteList = response.data["data"]));
    },
    getPerfilList() {
      api
        .get(`crud/Perfil`, {
          params: {
            sortBy: "descricao",
            sortOrder: "ASC"
          }
        })
        .then(response => {
          this.perfilList = response.data["data"];
          if (!this.perfilId) {
            this.perfilId = this.item.perfilId;
          }
        });
    },
    getConsultorList() {
      api
        .get(`crud/Consultor`, {
          params: {
            sortBy: "nome",
            sortOrder: "ASC"
          }
        })
        .then(response => (this.consultorList = response.data["data"]));
    }
  }
};
</script>

<template>
  <div>
    <b-form @submit.prevent="save">
      <b-form-group id="input-group-1" label="Nome" label-for="nome">
        <b-form-input
          id="nome"
          v-model="item.nome"
          type="text"
          :disabled="!this.editForm"
          required
        ></b-form-input>
      </b-form-group>

      <b-form-group id="input-group-1" label="E-mail" label-for="email">
        <b-form-input
          id="email"
          v-model="item.email"
          type="email"
          :disabled="!this.editForm"
          required
        ></b-form-input>
      </b-form-group>

      <b-form-group id="input-group-1" label="Perfil" label-for="perfilId">
        <b-form-select
          id="perfilId"
          v-model="perfilId"
          :disabled="!this.editForm"
          required
        >
          <b-form-select-option disabled :value="undefined"
            >Selecione um item da lista</b-form-select-option
          >
          <b-form-select-option
            v-for="option in perfilList"
            :key="option.id"
            :value="option.id"
          >
            {{ option.descricao }}
          </b-form-select-option>
        </b-form-select>
      </b-form-group>

      <b-form-group
        id="input-group-1"
        label="Consultor"
        label-for="consultorId"
        v-show="associaConsultor"
      >
        <b-form-select
          id="consultorId"
          v-model="consultorId"
          :disabled="!this.editForm"
          :required="this.associaConsultor"
        >
          <b-form-select-option disabled :value="undefined"
            >Selecione um item da lista</b-form-select-option
          >
          <b-form-select-option
            v-for="option in consultorList"
            :key="option.id"
            :value="option.id"
          >
            {{ option.nome }}
          </b-form-select-option>
        </b-form-select>
      </b-form-group>

      <b-form-group
        id="input-group-1"
        label="Cliente"
        label-for="clienteId"
        v-show="associaCliente"
      >
        <b-form-select
          id="clienteId"
          v-model="clienteId"
          :disabled="!this.editForm"
          :required="this.associaCliente"
        >
          <b-form-select-option disabled :value="undefined"
            >Selecione um item da lista</b-form-select-option
          >
          <b-form-select-option
            v-for="option in clienteList"
            :key="option.id"
            :value="option.id"
          >
            {{ option.nome }}
          </b-form-select-option>
        </b-form-select>
      </b-form-group>

      <b-form-group
        id="input-group-ativo"
        label-for="ativo"
        class="mt-3 text-right"
      >
        <b-form-checkbox  v-model="item.ativo"                   
          >Ativo
        </b-form-checkbox>
      </b-form-group>

      <b-form-group id="button-group" class="mt-4" v-show="this.editForm">
        <b-button variant="light" class="btn" v-on:click="back()"
          >Cancelar</b-button
        >
        <b-button type="submit" variant="primary" class="btn ml-2"
          >Salvar</b-button
        >
      </b-form-group>

      <b-form-group id="button-group" class="mt-4" v-show="!this.editForm">
        <b-button variant="light" class="btn" v-on:click="back()"
          >Voltar</b-button
        >
        <b-button variant="primary" class="btn ml-2" v-on:click="edit()"
          >Editar</b-button
        >
        <b-button variant="danger" class="btn ml-2" v-on:click="remove()"
          >Remover</b-button
        >
      </b-form-group>
    </b-form>
    <b-modal
      v-model="showModalDelete"
      title="Deseja realmente excluir?"
      centered
      hide-footer
      @hidden="cancelRemove()"
    >
      <div class="button-list float-right">
        <b-button
          class="btn btn btn-icon"
          variant="primary"
          v-on:click="confirmRemove()"
          >Sim</b-button
        >
        <b-button
          class="btn btn btn-icon"
          variant="light"
          @click="showModalDelete = false"
          >Não</b-button
        >
      </div>
    </b-modal>
  </div>
</template>
